export default import.meta.ROLLDOWN_FILE_URL_gcb9OGcZuPgUxyaFwWeVIw